import { render, staticRenderFns } from "./editApp.vue?vue&type=template&id=0c1ef6b3&scoped=true&"
import script from "./editApp.vue?vue&type=script&lang=js&"
export * from "./editApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ef6b3",
  null
  
)

export default component.exports